<template>
  <div :class="$style.container">
    <h2 id="title-tiktokSetup">
      {{title}}
    </h2>
    <div :class="[$style.wrapper, $style[current === index ? 'isFocus' : '']]">
      <div v-if="!isAccessible" :class="$style.layer"></div>
      <p :class="$style.text">Click the button below to get invited to your TikTok Ad Account.</p>
      <el-button
        id="tiktok-account-access"
        type="primary"
        size="medium"
        :disabled="!canRequestAppAccess"
        :loading="loadingRequestAccess"
        :class="$style.requestButton"
        data-test-id="gameSubmissionTikTokRequestAccountAccess"
        @click="requestTikTokAccountAccess()"
      >
        Request TikTok Account Access
      </el-button>
      <p :class="$style.subtext">
        Once you have accepted the invitation, click Validate to fetch your TikTok App ID.
      </p>
      <p v-if="tiktokAppId" :class="$style.appId" data-test-id="gameSubmissionTikTokAppId">
        TikTok App ID: <strong>{{ tiktokAppId }}</strong>
      </p>
      <p v-else-if="validationAttempted" :class="$style.error" data-test-id="gameSubmissionTikTokAppIdError">
        No TikTok App ID found yet. Make sure access has been granted, then try again.
      </p>
      <el-button
        id="validate-tiktok"
        type="primary"
        size="small"
        :disabled="!canRequestAppAccess"
        :loading="tikTokLoading"
        :class="$style.validateBtn"
        data-test-id="gameSubmissionTikTokSetupValidate"
        @click="validate()"
      >
        <span>Validate</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import tools from '@/tools/tools';

export default {
  props: {
    game: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
    current: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: 'no name',
    },
    step: {
      type: Object,
      default: null,
    },
    steps: { // alternative: provide / inject
      type: Array,
      default: null,
    },
    warning: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isvisible: false,
      loadingRequestAccess: false,
      validationAttempted: false,
    };
  },
  computed: {
    isAccessible() {
      return this.index === 0 || this.steps[this.index - 1].isValid;
    },
    canRequestAppAccess() {
      return (
        this.gamePermissions.includes('request_application_access')
        || this.myPermissions.includes('request_application_access')
      );
    },
    gamePermissions() {
      return Object.keys(this.game.permissions);
    },
    myPermissions() {
      return this.$store.getters['users/myPermissions'];
    },
    tikTokLoading() {
      return this.$store.getters['submitGame/tiktokLoading'] || false;
    },
    tiktokAppId() {
      return this.game?.adNetworks?.tiktok?.appId || null;
    },
  },
  mounted() {
    tools.attachEvent(document.getElementById('container-scrollable'), 'scroll', this.update);
    tools.attachEvent(window, 'resize', this.update);
  },
  methods: {
    update() {
      const titleElement = document.getElementById('title-tiktokSetup');
      const isvisible = tools.visibleY(titleElement);
      if (this.isvisible !== isvisible) {
        if (this.isAccessible && isvisible) {
          this.$emit('change', this.index);
        }
        this.isvisible = isvisible;
      }
    },
    async requestTikTokAccountAccess() {
      this.loadingRequestAccess = true;
      const response = await this.$store.dispatch(
        'gameAction/requestTikTokAccountAccess',
        { game: this.game },
      );
      this.loadingRequestAccess = false;
      if (response && !response.error) {
        Message({
          message:
            '<strong>Action <i style="color:blue;">Request TikTok Account Access</i></strong> done!',
          type: 'success',
          dangerouslyUseHTMLString: true,
          duration: 5000,
          showClose: true,
        });
      } else {
        Message({
          message:
            '<strong>Action <i style="color:blue;">Request TikTok Account Access</i></strong> failed!',
          type: 'error',
          dangerouslyUseHTMLString: true,
          duration: 5000,
          showClose: true,
        });
      }
    },
    async validate() {
      this.validationAttempted = true;
      const response = await this.$store.dispatch('submitGame/getTikTokAppId', this.game);
      if (response?.data?.appId) {
        this.$emit('isValid', this.index);
      }
    },
  },
};
</script>

<style lang="scss" module>

.container {
  padding: $spacing * 3;
  display: block;
  h2 {
    font-size: 16px;
    padding-bottom: 16px;
    text-align: left;
  }
}
.isFocus {
  -webkit-box-shadow: 0px 0px 19px 3px rgba(0,0,0,0.10);
  box-shadow: 0px 0px 19px 3px rgba(0,0,0,0.10);
}
.wrapper {
  border-radius: 16px;
  border: solid 1px $foggy-grey;
  text-align: left;
  font-size: 12px;
  padding: $spacing * 3;
  position: relative;
  .layer{
    border-radius: 16px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(255 255 255 / 80%);
    z-index: 10;
  }
}

.text {
  font-weight: 600;
  margin-bottom: $spacing;
}

.subtext {
  color: $grey;
  line-height: 1.4;
  margin-top: $spacing * 3;
  margin-bottom: $spacing;
}

.requestButton {
  margin-top: $spacing;
}

.validateBtn {
  margin-top: $spacing * 3;
}

.appId {
  margin-top: $spacing;
  font-weight: 600;
}

.error {
  margin-top: $spacing;
  font-size: 12px;
  color: $blood-normal;
}
</style>
